'use strict';

angular.module('DoohApps')
.filter('sortClassFilter', function () {
    return function (sortValue) {
        // 1 - data is currently sorted in asc order
        // 2 - data is currently sorted in desc order
        // 0 - data currently isn't sorted by this filter. By default we start sorting in asc order
        switch (sortValue) {
            case 1:
                return 'fa-sort-asc';
            case 0:
            case 2:
                return 'fa-sort-desc';
        }
    }
});